import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { InstructivoEmbarqueStateService } from '../../../services/instructivo-embarque-state.service';
import { WizardInitResponseDto } from '@opb-workspace/shared';

@Component({
  selector: 'app-step1-viaje',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, MatChipsModule],
  templateUrl: './step1-viaje.component.html',
  styleUrls: ['./step1-viaje.component.scss'],
})
export class Step1ViajeComponent {
  constructor(public stateService: InstructivoEmbarqueStateService) {}

  get voyage(): WizardInitResponseDto | null {
    return this.stateService.snapshot.voyageData;
  }

  /** Texto único del bloque Stacking (horario descriptivo desde el itinerario). */
  get stackingLine(): string {
    const raw = this.voyage?.stackingDescription;
    const t = raw?.trim();
    return t && t.length > 0 ? t : '—';
  }

  get emisorBl(): string {
    const v = this.voyage;
    if (!v) return '—';
    const issuer = v.billOfLadingIssuer?.trim();
    if (issuer) return issuer;
    return v.carrierName?.trim() || '—';
  }

  get transitDaysDisplay(): string {
    const n = this.voyage?.transitDays;
    if (n === null || n === undefined || Number.isNaN(Number(n))) return '—';
    return String(n);
  }
}
